import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Footer, Home, Navigation, Projects, Resume } from "./components";
import Publications from "./components/Publications";

const data = require.context("../public/static/data/", true);
var publicationList = data(`./publications.json`);
var projectList = data(`./projects.json`);

export default class App extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const data = {
      publications: publicationList,
      projects: projectList,
    };

    return (
      <div className="App">
        <Router>
          <Navigation />
          <Switch>
            <Route path="/" exact component={() => <Home />} />
            <Route
              path="/projects"
              exact
              component={() => <Projects data={data} />}
            />
            <Route
              path="/publications"
              exact
              component={() => <Publications data={data} />}
            />
            <Route
              path="/resume"
              exact
              component={() => <Resume data={data} />}
            />
          </Switch>
          <Footer />
        </Router>
      </div>
    );
  }
}
